import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// ALGOLIA SEARCH
import algoliasearch from 'algoliasearch/lite';

// Redux
import { connect } from 'react-redux';

// Actions
import { getRecentSearches, deleteRecentSearch, clearRecentSearch } from '../../actions/searchActions';

// Components - imported
import { Button, Avatar } from '@material-ui/core';
import Spinner from '../common/Spinner';

// Icons - imported
import SearchIcon from '@material-ui/icons/Search';
import GroupIcon from '@material-ui/icons/Group';
import MailIcon from '@material-ui/icons/Mail';
import RoomIcon from '@material-ui/icons/Room';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';

const Contact_Widget = ({ 
    auth,
    search: {
        recent_searches,
        recent_loading
    },
    getRecentSearches,
    deleteRecentSearch, 
    clearRecentSearch, 
    notFullScreen 
}) => {

    // --- Search stuff

    const [inputClicked, setInputClicked] = useState(false);

    const [searchText, setSearchText] = useState('');

    const [searchRecommendations, setSearchRecommendations] = useState([]);

    const [dropdownOptionIndex, setDropdownOptionIndex] = useState(-1);

    const [searchDropdownArray, setSearchDropdownArray] = useState([]);

    useEffect(() => {

        if(auth.user) {
            // Get recent searches
            getRecentSearches(auth.user._id);
        }

    }, [auth.user]);

    // Update the array for counting the search dropdown index for when up/down arrows are clicked
    useEffect(() => {

        if(searchDropdownArray.length === 0 && recent_searches.length > 0) {
            setSearchDropdownArray([...recent_searches])
        } else {
            setSearchDropdownArray([...searchRecommendations, ...recent_searches])
        }

    }, [searchRecommendations, recent_searches]);

    useEffect(() => {

        if(!inputClicked) {
            setDropdownOptionIndex(-1);
        }

    }, [inputClicked]);

    useEffect(() => {
        // 👇 Get the Input element by Id
      const searchInput = document.getElementById('search-input');
      
      if (!searchInput) return;
  
  
      searchInput.addEventListener("focusin", (event) => {
        console.log('FOCUS IN')
        setInputClicked(true);
      });
      
    //   searchInput.addEventListener("focusout", (event) => {
    //     console.log('FOCUS OUT')
    //     setInputClicked(false);
    //   });

      return () => {
        searchInput.removeEventListener("focusin", (event) => {
            console.log('FOCUS IN')
            setInputClicked(true);
        });
        
        // searchInput.removeEventListener("focusout", (event) => {
        //     console.log('FOCUS OUT')
        //     setInputClicked(false);
        // });
      };

    }, []);

    const searchRecommendationClient = algoliasearch('H8YQ3RB3ZI', '8ad74b3884c12ec628eb17e0e9f49935');

    const recommendationIndex = searchRecommendationClient.initIndex('searches');

    // Function to handle input change
    const onChange = e => setSearchText(e.target.value);

    const onDownArrow = () => {

        console.log('SEARCH ARRAY')
        console.log(searchDropdownArray.length)

        console.log('SEARCH INDEX')
        console.log(dropdownOptionIndex + 1)

        console.log('REQ LENGTH INDEX')
        console.log(searchRecommendations.length)


        let nextIndex = dropdownOptionIndex + 1;

        if(nextIndex > searchDropdownArray.length - 1) {
            nextIndex = 0;
        }

        setDropdownOptionIndex(nextIndex);
    }

    const onUpArrow = () => {

        let nextIndex = dropdownOptionIndex - 1;

        if(nextIndex === -1 ) {
            nextIndex = searchDropdownArray.length - 1;
        }

        setDropdownOptionIndex(nextIndex);
    }

    const handleSubmit = async (queryText) => {
        if(dropdownOptionIndex > -1) {
            window.location.href = `/search?q=${searchDropdownArray[dropdownOptionIndex].text ? searchDropdownArray[dropdownOptionIndex].text : searchDropdownArray[dropdownOptionIndex].search_text}`;

            console.log('SEARCH THIS WORD')
            console.log(searchDropdownArray[dropdownOptionIndex]);
        } else {
            if(queryText === '') return;

            window.location.href = `/search?q=${queryText}`;
        }
    }

    const handleRecommendations = async (queryText) => {

        setDropdownOptionIndex(-1); // Reset search dropdown index

        try {

            if(queryText === '') return;

            const results = await recommendationIndex.search(queryText);

            console.log('SEARCH RESULT');
            console.log(results);

            setSearchRecommendations(results.hits.map((doc) => ({...doc, _id: doc.objectID})));

            setSearchDropdownArray([...results.hits.map((doc) => ({...doc, _id: doc.objectID})), ...searchDropdownArray]);

        } catch (error) {
            console.log(error);
            setSearchRecommendations([]);
        }
    }

    let recommendations_list = [];

    if(searchRecommendations.length > 0) {

        // Iterate through the posts array and render each post component   
        for (let i = 0; i < searchRecommendations.length; i++) {
            const recommendation = searchRecommendations[i];
            
            if (recommendation) {
                recommendations_list.push(
                <div key={recommendation._id} onClick={() => window.location = `/search?q=${recommendation.text}`} className={dropdownOptionIndex === i ? "search-dropdown-item active" : "search-dropdown-item"}>
                    <div className='search_dropdown_item_icon'>
                    <SearchIcon />
                    </div>
                    <div className='search_dropdown_item_option'>
                    <div style={{fontWeight:700}}>
                        {recommendation.text}
                    </div>
                    </div>
                </div>
                );
            }
        }
    }

    let recent_list;

    if(auth.isAuthenticated && (recent_searches === null || recent_loading)) {
        recent_list = <Spinner />;
    } else if(recent_searches.length > 0) {

        recent_list = [];

        // Iterate through the recent_searches array and render each search query component
        for (let i = 0; i < recent_searches.length; i++) {
            const recent_search = recent_searches[i];

            if(recent_search) {
                recent_list.push(
                    <div key={recent_search._id} className={dropdownOptionIndex === searchRecommendations.length + i ? "search-dropdown-item active" : "search-dropdown-item"}>
                        <div className='search_dropdown_item_icon'>
                            <SearchIcon />
                        </div>
                        <div className='search_dropdown_item_option'>
                            <div>
                                {recent_search.search_text}
                            </div>
                            <div className='search__actionBtn' onClick={() => deleteRecentSearch(auth.user._id, recent_search._id)}>
                                <CloseIcon />
                            </div>
                        </div>

                        {/* Post Overlay to detect when clicked and redirect to postPage */}
                        <div 
                            className="post__overlay" 
                            onClick={() => window.location = `/search?q=${recent_search.search_text}`}
                        ></div>
                    </div>
                )
            }
        }
        
    } else {
        recent_list = null;
    }

    return (
        <div className="widgets">

            <div className={`widgets__authContainer ${notFullScreen ? 'in_mobile_feed' : ''}`}>

                {/* Title */}
                <h2>Contact Us</h2>

                {/* Website info */}
                <div className="widgets__authStats group">
                    <MailIcon />
                    <span style={{fontWeight:'500'}}>Email: support@buysell.app</span>
                </div>


                {/* Button for widget box (sign up or share website if logged in) */}
                <div style={{marginBottom:'16px'}}>
                    <Button onClick={() => window.open(`https://www.instagram.com/buysell.app/`, "_blank")} variant="outlined" className="sidebar__tweet ghost" fullWidth>
                        DM us on Instagram
                    </Button>
                </div>

                {/* Small disclaimer text under action button */}
                <div className="widgets__authDisclaimer">
                    By signing up, you agree to the <a href="/settings/terms">Terms of Service</a> and <a href="/settings/privacy">Privacy Policy</a>, including <a href="/settings/privacy#cookies">Cookie Use.</a>
                </div>
            </div>

            {/* Footer - bottom nav */}
            <div className="widgets__footer">
                <nav>
                    <a href="/settings/terms">
                        Terms of Service
                    </a>
                    <a href="/settings/trust_and_safety">
                        Trust/Safety
                    </a>
                    <a href="/settings/returns">
                        Returns
                    </a>
                    <a href="/settings/about">
                        About
                    </a>
                    <a href="/settings/help">
                        Help
                    </a>
                    <div>
                        © 2026 BuySellApp
                    </div>
                </nav>
            </div>

            {/* <div className="widgets__widgetContainer">
                <h2>What's happening</h2>

                <TwitterTweetEmbed tweetId={"858551177860055040"} />
            </div> */}
        </div>
    )
}

Contact_Widget.propTypes = {
    auth: PropTypes.object.isRequired, // Prop: Object representing authentication state
    search: PropTypes.object.isRequired,
    getRecentSearches: PropTypes.func.isRequired,
    deleteRecentSearch: PropTypes.func.isRequired,
    clearRecentSearch: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth, // Connect: Map authentication state from redux store to auth prop
    search: state.search
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    getRecentSearches, 
    deleteRecentSearch, 
    clearRecentSearch 
})(Contact_Widget);